import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    lng: 'de', // Force German language - no detection
    debug: false,
    interpolation: {
      escapeValue: false
    },
    // Disable language detection - always use German
    // detection: false
  });

// Force German language on initialization and prevent changes
i18n.changeLanguage('de');

export default i18n;

